import qs from 'qs';
import isArray from 'lodash/isArray';
import map from 'lodash/map';
import mapKeys from 'lodash/mapKeys';
import camelCase from 'lodash/camelCase';

export function checkResponse(response: any) {
    if (response.data.st === 0) {
        return response.data.data;
    }

    throw response.data;
}

export enum PAGE_ERROR_TYPE {
    NETWORK_ERROR = 0,
    OTHER_ERROR = 1
}

export interface PageError {
    type: PAGE_ERROR_TYPE;
    message: string;
}

// Create page error
export function createPageError(type: PAGE_ERROR_TYPE, message: string): PageError {
    return {
        type,
        message
    };
}

// 将设计稿像素值换算到当前屏幕宽度下
export function calcPX(px: number) {
    const screenWidth = document.body.offsetWidth;
    return (px * screenWidth) / 375;
}

export interface GoodsDetailParams {
    promotion_id: string; // 没有promotion_id就传入product_id
    item_id?: string;
    author_id: number;
    sec_author_id: number;
    source_page: string;
    entrance_info?: any;
}
// 商详页schema
export function genGoodsDetailSchema(params: GoodsDetailParams) {
    const host = 'sslocal://ec_goods_detail/';
    const request_additions = {
        sec_author_id: params.sec_author_id,
        enter_from: params.source_page
    };
    const query: any = {
        promotion_id: params.promotion_id,
        kol_id: params.author_id,
        source_page: params.source_page,
        request_additions: JSON.stringify(request_additions)
    };
    if (params.item_id) {
        query.item_id = params.item_id;
    }
    if (params.entrance_info) {
        query.meta_params = JSON.stringify({
            entrance_info: JSON.stringify(params.entrance_info)
        });
    }
    return `${host}?${qs.stringify(query, { encode: true, encoder: encodeURIComponent })}`;
}

export const safeParse = (str: string, defaultVal = {}) => {
    try {
        return JSON.parse(str);
    } catch {
        return defaultVal;
    }
};

export const camelCaseKey = (o: any): any => {
    if (isArray(o)) {
        return map(o, camelCaseKey);
    }

    return mapKeys(o, (_value, key) => camelCase(key));
};
